

export default function* watcher(): Generator {

}
